/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { PureComponent } from 'react'
import { Form, Input } from 'semantic-ui-react'

export default class AbaNumberField extends PureComponent {
  render() {
    const { value, onChange, name } = this.props

    return (
      <Form.Field>
        <label>ABA Number</label>
        <Input
          placeholder="e.g 000111222"
          type="number"
          onChange={e => onChange('aba', { number: e.target.value, name })}
          value={value}
        />
      </Form.Field>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/fields/abaNumberField.js